var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03. Icons/Log out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M48 21.75C52.2947 21.75 56.6638 25.0486 56.9816 29.1485L57 29.625V35.25C57 36.4926 55.9926 37.5 54.75 37.5C53.6109 37.5 52.6695 36.6535 52.5205 35.5553L52.5 35.25V29.625C52.5 28.1636 50.4627 26.476 48.4101 26.2708L48 26.25H26.625C24.8853 26.25 23.453 27.5663 23.2698 29.2573L23.25 29.625V63.375C23.25 65.1147 24.5663 66.547 26.2573 66.7302L26.625 66.75H49.125C50.8647 66.75 52.297 65.4337 52.4802 63.7427L52.5 63.375V57.75C52.5 56.5074 53.5074 55.5 54.75 55.5C55.8891 55.5 56.8305 56.3465 56.9795 57.4447L57 57.75V63.375C57 67.557 53.7402 70.9776 49.623 71.2345L49.125 71.25H26.625C22.443 71.25 19.0224 67.9902 18.7655 63.873L18.75 63.375V29.625C18.75 25.443 22.0098 22.0224 26.127 21.7655L26.625 21.75H48Z",
    fill: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M62.159 33.659C62.9578 32.8602 64.2078 32.7876 65.0886 33.4412L65.341 33.659L76.591 44.909C77.3898 45.7078 77.4624 46.9578 76.8088 47.8386L76.591 48.091L65.341 59.341C64.4623 60.2197 63.0377 60.2197 62.159 59.341C61.3602 58.5422 61.2876 57.2922 61.9412 56.4114L62.159 56.159L71.817 46.5L62.159 36.841C61.3602 36.0422 61.2876 34.7922 61.9412 33.9114L62.159 33.659Z",
    fill: "#3F3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M72.75 44.3291C73.9926 44.3291 75 45.3365 75 46.5791C75 47.7182 74.1535 48.6596 73.0553 48.8086L72.75 48.8291H36.75C35.5074 48.8291 34.5 47.8217 34.5 46.5791C34.5 45.44 35.3465 44.4986 36.4447 44.3496L36.75 44.3291H72.75Z",
    fill: "#3F3E3E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOut);
export default __webpack_public_path__ + "static/media/icon-log-out.886d16aad9f0c45a804176c126458b39.svg";
export { ForwardRef as ReactComponent };